<template>
  <el-drawer
    title=""
    custom-class="car-drawer-cont"
    :visible.sync="drawerVisible"
    :close-on-press-escape="false"
    :destroy-on-close="destroyOnClose"
    :wrapper-closable="false"
    :append-to-body="appendToBody"
    :direction="direction"
    :size="size"
    @close="carDrawerClose"
    @open="carDrawerOpen"
    @closed="carDrawerClosed"
    @opened="carDrawerOpened"
  >
    <slot class="slot-cont-drawer" />
    <span class="close-drawer-icon" @click="carDrawerClose">
      <i class="el-icon-arrow-right" color="#666666" />
    </span>
  </el-drawer>
</template>
<script>
export default {
  props: {
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    closeOnPress: {
      type: Boolean,
      default: false
    },
    wrapperClosable: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '500'
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    openDrawer() {
      this.drawer = true
    },
    closeDrawer() {
      this.drawer = false
    },
    carDrawerOpen() {
      this.$emit('carDrawerOpen')
    },
    carDrawerClose() {
      this.$emit('carDrawerClose')
    },
    clickCarDrawer() {
      this.drawer = false
    },
    carDrawerClosed() {
      this.$emit('carDrawerClosed')
    },
    carDrawerOpened() {
      this.$emit('carDrawerOpened')
    }
  }
}
</script>

<style lang="scss" scoped>
.close-drawer-icon {
  display: block;
  width: 27px;
  height: 68px;
  position: absolute;
  top: 45%;
  left: 1px;
  // z-index: 800;
  // border-radius: 28px 0 0 28px;
  // background: white;
  background: url("~@/assets/drawer-close.png") no-repeat;
  background-size: 100% 100%;
  line-height: 60px;
  text-align: right;
  cursor: pointer;
  .el-icon-arrow-right {
    line-height: 68px;
    margin-right: 2px;
    &::before {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
/deep/ .el-drawer {
  padding-left: 28px!important;
  box-shadow: none!important;
  background: none!important;
  .el-drawer__header{
    height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
}
.slot-cont-drawer {
  background: white;
}
</style>
